import classNames from 'classnames';
import Img from 'gatsby-image';
import React, { useCallback, useEffect, useState } from 'react';
import { ReactComponent as PlayIcon } from '../../../assets/icons/play.svg';
import { TechImageSharpFluid_withWebp } from '../../../graphql-generated';
import './vimeoPlayer.scss';

const loadVimeo = () => import('@vimeo/player');

export type VimeoPlayerProps = {
  video?: string;
  image?: TechImageSharpFluid_withWebp;
};

export const VimeoPlayer = ({ video, image }: VimeoPlayerProps) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const iframeRef = React.useRef<HTMLIFrameElement>(null);
  const vimeoApiRef = React.useRef<typeof import('@vimeo/player').Player>();
  const playerRef = React.useRef<
    InstanceType<typeof import('@vimeo/player').Player>
  >();

  const onClick = useCallback(() => {
    setIsPlaying(true);
    playerRef.current?.play();
  }, []);

  useEffect(() => {
    loadVimeo().then((res) => {
      vimeoApiRef.current = res.default;
      setLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (!loaded) return;
    if (!iframeRef.current) return;
    if (!vimeoApiRef.current) return;

    playerRef.current = new vimeoApiRef.current(iframeRef.current);
  }, [loaded]);

  return (
    <div className="vimeo-player">
      <iframe
        src={video}
        ref={iframeRef}
        frameBorder="0"
        className="vimeo-player__iframe"
        allowFullScreen
      ></iframe>
      <div
        className={classNames('vimeo-player__poster', {
          'vimeo-player__poster--hidden': isPlaying,
        })}
        onClick={onClick}
      >
        <Img fluid={image as any} />
        <div className="vimeo-player__play">
          <div className="vimeo-player__play-icon">
            <PlayIcon />
          </div>
        </div>
      </div>
    </div>
  );
};
